import Vue from 'vue';
import Router from 'vue-router';
import Private from '../views/private/private';
//import Application from '../views/public/application';
import Public from '../views/public/application';
import {PrivateRoutes} from '../views/private/router';
import { PublicRoutes } from '../views/public/router';
/* Routes */

Vue.use(Router);

export default new Router({
	//mode: 'history',
	routes: [
		{
			path: '/',
			component: Private,
			children: PrivateRoutes,
			meta: {
				auth: true
			}
		},
		{
			path: '/public',
			component: Public,
			children: PublicRoutes,
			meta: {
				auth: false
			}
		}
	]
})
